module.exports = __webpack_public_path__ + "static/media/Seismic_Table_C1_C2_FR.47eb08e1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Seismic_Table_C1_C2_FR.png
// module id = 1328
// module chunks = 0